import * as React from 'react';
import { SummaryData, TimeType, timeTypesConfigMap } from './common';
import { formatValue } from '../../utils/common';
import { css } from 'office-ui-fabric-react';

type Props = {
    summaryData: SummaryData,
    baselineEffort?: number,
    timeType: TimeType[],
    editableTimeType: TimeType[],
    isNonWorking: boolean,
    startEditing?: (editTimeType: TimeType) => void;
}

const ViewMode = (props: Props) => {
    const { timeType, summaryData, startEditing, baselineEffort, editableTimeType, isNonWorking } = props;

    const isTimeTypeOn = (_: TimeType) => timeType.includes(_);

    return <>
        {isTimeTypeOn("Effort") 
            && <CellValue 
                value={summaryData.effort} 
                isEmpty={!summaryData.hasValue} 
                timeType={'Effort'} 
                isEditable={!!startEditing && editableTimeType.includes('Effort')} 
                isNonWorking={isNonWorking}
                onDoubleClick={() => startEditing?.('Effort')} />}
        {isTimeTypeOn('CompletedWork') 
            && <CellValue 
                value={summaryData.completedWork} 
                isEmpty={!summaryData.hasValue} 
                timeType={'CompletedWork'} 
                isEditable={!!startEditing && editableTimeType.includes('CompletedWork')} 
                isNonWorking={isNonWorking}
                onDoubleClick={() => startEditing?.('CompletedWork')} />}
        {isTimeTypeOn("RemainingWork") 
            && <CellValue 
                value={summaryData.remainingWork} 
                isEmpty={!summaryData.hasValue} 
                timeType={'RemainingWork'}
                isNonWorking={isNonWorking}
                onDoubleClick={() => startEditing?.('RemainingWork')} />}
        {isTimeTypeOn('BaselineEffort') 
            && <CellValue value={baselineEffort} isEmpty={!baselineEffort} isNonWorking={isNonWorking} timeType={'BaselineEffort'} />}
    </>;
}

const CellValue = (props: {
    value: number | undefined | null, isEmpty?: boolean, timeType: TimeType, isEditable?: boolean, isNonWorking: boolean,
    onDoubleClick?: React.MouseEventHandler<HTMLDivElement>;
}) => {
    const { value, isEmpty, timeType, isEditable, isNonWorking, onDoubleClick } = props;
    const formattedValue = value === null ? "-" : formatValue(value);
    return <div aria-hidden
        onDoubleClick={isEditable && onDoubleClick ? (ev) => { onDoubleClick(ev); ev.stopPropagation(); } : undefined}
        className={css('value-wrap align-center', timeTypesConfigMap[timeType].className, isEditable && 'editable', !value && 'no-data', isNonWorking && 'non-working-day')}
        title={timeTypesConfigMap[timeType].title}>
        {!isEmpty && <div className="value">{formattedValue}</div>}
        {!isEmpty && <div className="unit">hours</div>}
    </div>;
}

export default ViewMode;